import React, {Component, Fragment} from "react";
import PropTypes from "prop-types";
import autobind from "autobind-decorator";
import { connect } from "react-redux";
import {
    Container,
    Row,
    Col,
    InputGroup,
    InputGroupAddon,
    Button,
    Input,
    UncontrolledTooltip,
    FormGroup,
    Label
} from 'reactstrap';

import LayoutDashboard from "../../../../views/layout/Dashboard";
import {layout} from "../../../../../ts-helpers/decorators";
import http from "../../../../services/HttpService";
import validate from "../../../../services/ValidationService";
import Loading from "../../../includes/Loading";
import {Redirect} from "react-router";
import Route from "../../../../Routes";
import {Link} from "react-router-dom";

@layout(LayoutDashboard)
@(connect((state) => {
    return { };
}) as any)

export default class Settings extends Component<any> {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
    };

    state = {
        errors: [],
        loading: false,
        submitted:false,
        passwordConfirm: {
            value: "",
            valid: false,
            touched: false,
        },
        password: {
            value: "",
            valid: false,
            touched: false,
        },
        oldPassword: {
            value: "",
            valid: false,
            touched: false,
        },
        newErrPassConfirm:'',
        newErrPass:'',
        newErrVerify:'',
        ee:false,
        updated:false,
        invalidPass:''
    };

    constructor(props: Map<any, any>) {
        super(props);
    }

    componentDidMount() {
        this.getData();
        this.props.onRef(this);
    }

    @autobind
    getData(){

    }

    @autobind
    validateOldPassword(event) {
        const { oldPassword } = this.state;
        oldPassword.value = event.target.value;
        oldPassword.valid = validate.password(event.target.value);
        oldPassword.touched = true;


        this.setState({
            oldPassword,
            newErrPass:'',
        });
    }

    @autobind
    validatePassword(event) {
        const { password, passwordConfirm, ee } = this.state;
        password.value = event.target.value;
        password.valid = validate.password(event.target.value);
        password.touched = true;

        if(password.value === passwordConfirm.value){
            var aaa = true;
        }else{
            var aaa = false;
        }

        this.setState({
            password,
            newErrPass:'',
            ee:aaa
        });
    }

    @autobind
    validatePasswordConfirm(event) {
        const { password, passwordConfirm, ee } = this.state;
        passwordConfirm.value = event.target.value;
        passwordConfirm.valid = validate.password(event.target.value);
        passwordConfirm.touched = true;

        if(password.value === passwordConfirm.value){
            var aaa = true;
        }else{
            var aaa = false;
        }

        this.setState({
            passwordConfirm,
            newErrPassConfirm:'',
            ee:aaa
        });
    }

    @autobind
    formChange(event) {
        event.preventDefault();
        this.setState({ submitted: true });
        this.setState({ loading: true });

        const { oldPassword, password, passwordConfirm } = this.state;
        if (!oldPassword.valid || !password.valid || !passwordConfirm.valid) {
            return;
        }

        http.post('/users/change-admin-password', {
            oldPassword: oldPassword.value,
            password: password.value,
        }).then((response: any) => {
            if (response.ok) {
                response.json().then((data: any) => {
                    if(data.status == "success"){
                        this.setState({
                            updated: true,
                            invalidPass:data.message
                        });
                    }else{
                        if(data.status == "lol"){
                            this.setState({
                                updated: false,
                                invalidPass:data.invalidPass
                            });
                        }
                    }
                });
            } else {
                response.json().then((jsonData: any) => {
                    this.setState({
                        errors: jsonData.errors,
                    });
                });
            }
        })
            .catch((err) => {
                console.log(err);
            });
    }

    render() {
        const { errors, oldPassword, password, passwordConfirm, loading, submitted, newErrPass, newErrPassConfirm, updated, invalidPass, ee } = this.state;
        // if (updated) {
        //     return <Redirect to={Route.toUrl("home")} />
        // }

        //console.log("invalidPass-",invalidPass);
        //console.log("updated-",updated);

        return(

            <Container fluid>
                <Row>
                    <Col xs={12}>
                        <h4 className="header-title m-t-0 m-b-20">Admin settings!</h4>
                    </Col>
                </Row>
                <Row>
                    <Col className="form_block_forgot_pass col-xs-6 col-xs-offset-3 col-sm-6 col-sm-offset-3">
                        <div className='forgot_title'>Change password</div>
                        <form onSubmit={this.formChange}>
                            <div className="form-group">
                                <input
                                    type="password"
                                    className="form-control"
                                    placeholder="Old password"
                                    onChange={this.validateOldPassword}
                                    value={oldPassword.value}
                                />
                                <div className='reg_errors_style'>
                                    {validate.showError(oldPassword, "Invalid password: min 6 letter, at least one digit.")}
                                    {validate.showDbError(errors, "password")}
                                    {newErrPass}
                                </div>
                            </div>
                            <div className="form-group">
                                <input
                                    type="password"
                                    className="form-control"
                                    placeholder="New password"
                                    onChange={this.validatePassword}
                                    value={password.value}
                                />
                                <div className='reg_errors_style'>
                                    {validate.showError(password, "Invalid password: min 6 letter, at least one digit.")}
                                    {validate.showDbError(errors, "password")}
                                    {newErrPass}
                                </div>
                            </div>
                            <div className="form-group">
                                <input
                                    type="password"
                                    className="form-control"
                                    placeholder="Confirm password"
                                    onChange={this.validatePasswordConfirm}
                                    value={passwordConfirm.value}
                                />
                                <div className='reg_errors_style'>
                                    {validate.showError(passwordConfirm, "Invalid password: min 6 letter, at least one digit.")}
                                    {validate.showDbError(errors, "password")}
                                    {newErrPassConfirm}
                                </div>
                            </div>

                            {
                                password.value.length >=6 && passwordConfirm.value.length >=6 && ee == false  &&
                                <div className='reg_errors_style_forgot'>
                                    Passwords does not match
                                </div>
                            }

                            {
                                invalidPass == 'Invalid password' && updated == false &&
                                <div className='admin_change_pass_lol'>
                                    {invalidPass}
                                </div>
                            }

                            {
                                invalidPass == 'Password changed' && updated == true &&
                                <div className='admin_change_pass_yes'>
                                    {invalidPass}
                                </div>
                            }

                            <Button className="my_sign_in_submit" disabled={!password.valid || !passwordConfirm.valid || ee == false} >
                                {submitted && loading && invalidPass == 'lol' ? <Loading isLoading={loading} icon="auth" /> : "Accept"}
                            </Button>
                        </form>
                    </Col>
                </Row>
            </Container>



            // <div className="container">
            //     <div className="row">
            //         <div className="col-sm-12">
            //             <h4 className="header-title m-t-0 m-b-20">Admin settings!</h4>
            //         </div>
            //     </div>
            //     <div className="row">
            //         <div className="col-sm-12">
            //             <div className="container block_forgot_password_page">
            //                 <div className="row">
            //
            //                 </div>
            //             </div>
            //         </div>
            //     </div>
            // </div>
        );

    }
}
